import {Graphics as PixiGraphics} from '@pixi/graphics';
import {_ReactPixi, Graphics} from '@pixi/react';
import {ColorSource} from 'pixi.js';
import {useCallback, useMemo} from 'react';
import {useRingDefinition} from '../state/RingDefinitionsSlice';
import {RingId} from '../SupplyChainPayloadTypes';


export const ringRadius = 20;
const innerRadius = ringRadius * 0.6;

export interface RingSpriteProps extends _ReactPixi.IGraphics {
    ringId: RingId;
    innerRef?: React.Ref<PixiGraphics> | undefined;
    overlap?: 'LEFT' | 'RIGHT' | 'NONE';
}

const colours:{[key: string]: ColorSource} = {
    RED: 0xff0000,
    GREEN: 0x00ff00,
    YELLOW: 0xffdd00,
    BLUE: 0x3355ff,
};

export function RingSprite({x, y, ringId, overlap = 'NONE', innerRef}: RingSpriteProps) {
    const ringDefinition = useRingDefinition(ringId);

    const colour = useMemo<ColorSource>(() =>{
        const ringColour = ringDefinition?.colour;
        if (!ringColour)
            return 0x000000;
        return colours[ringColour + ''];
    }, [ringDefinition?.colour]);

    const draw = useCallback((graphics: PixiGraphics) => {
        if (overlap === 'NONE') {
            graphics
                .clear()
                .lineStyle({width:1.8, color:0x000000})
                .beginFill(colour, 1)
                .drawCircle(0, 0, ringRadius)
                .beginHole()
                .drawCircle(0, 0, innerRadius);
        } else {
            const startArc: number = overlap === 'LEFT' ? -1.8 : -0.9 ;
            const endArc: number = overlap === 'LEFT' ? -2.3 : -1.4;
            graphics
                .clear()
                .lineStyle({width: 1.8, color: 0x000000})
                .beginFill(colour, 1)
                .arc(0, 0, innerRadius, endArc, startArc, true)
                .arc(0, 0, ringRadius, startArc, endArc, false)
                .finishPoly();
        }
    }, [colour]);

    if (!ringDefinition)
        return <></>;

    return <Graphics ref={innerRef} x={x} y={y} draw={draw} />;
}
